import React from 'react';
import { motion } from 'framer-motion';
import { servicesData } from '@/data/content';
import { eventBus } from '@/utils/eventBus';
import SafeIcon from '@/common/SafeIcon';

const Services = () => {
  return (
    <section id="services" className="py-32 bg-surface-50">
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-20 gap-8">
          <div className="max-w-2xl">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-8 h-px bg-accent"></div>
              <span className="text-accent font-medium tracking-[0.2em] uppercase text-xs">Portofolio Layanan</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-serif text-slate-900 leading-tight">
              Destinasi Pilihan <br />Untuk <span className="italic text-primary">Jiwa Penjelajah</span>
            </h2>
          </div>
          <p className="text-gray-500 max-w-md md:text-right font-light leading-relaxed">
            Kurasi perjalanan eksklusif yang dirancang khusus untuk memenuhi ekspektasi tertinggi Anda, baik untuk rekreasi maupun ibadah.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-16">
          {servicesData.map((service, index) => (
            <motion.div 
              key={service.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="group cursor-pointer"
              onClick={() => eventBus.dispatch('openBookingModal', { service: service.title })}
            >
              <div className="relative h-[400px] overflow-hidden rounded-sm mb-6">
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-slate-900/10 group-hover:bg-transparent transition-colors duration-500"></div>
              </div>
              
              <div className="pr-8">
                <div className="flex justify-between items-start mb-4">
                  <h3 className="text-2xl font-serif text-slate-900 group-hover:text-primary transition-colors">
                    {service.title}
                  </h3>
                  <div className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-400 group-hover:bg-primary group-hover:text-white group-hover:border-primary transition-all duration-300 transform group-hover:-rotate-45">
                    <SafeIcon name="Send" className="w-4 h-4" />
                  </div>
                </div>
                <p className="text-gray-600 font-light leading-relaxed mb-6">
                  {service.description}
                </p>
                <div className="w-full h-px bg-gray-200 group-hover:bg-primary/30 transition-colors"></div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;